import { BaseDataModel } from "@domain/shared/types/BaseDataModel";

export class Branch extends BaseDataModel {
	name!: string;
	labAccountNumber!: string;
	salespersonIds!: string[];
	externalLocationId?: string[];
}
